import React, { useState } from "react";
import PreLoaderWidget from '../../../components/Loader';
import Receita from "../../../components/Receita";
import ModalComponent from "../../../components/Modal";
import CardReceita from "./components/CardReceita";

const ContReceita = ({ interacao, receita, paciente, preloadReceita, usuario, carregar }) => {

  const [itemReceita, setItemReceita] = useState(null);
  const [visibleModal, setVisibleModal] = useState(false);

  const openModal = (item) => {
    setVisibleModal(true);
    setItemReceita(item);
  }

  return (
    <>
      <div className="p-2">

        {preloadReceita ? (<PreLoaderWidget />) : receita
          ? receita.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-sm-12">
                  <CardReceita
                    interacao={interacao}
                    paciente={paciente}
                    profissional={item.profissional.nome}
                    DataCriacao={item.receita.DataCriacao}
                    prescricao_1={item.receita.prescricao_1}
                    prescricao_2={item.receita.prescricao_2}
                    prescricao_3={item.receita.prescricao_3}
                    Hora={item.receita.Hora}
                    prescricao_4={item.receita.prescricao_4}
                    remedio_1={item.receita.remedio_1}
                    remedio_2={item.receita.remedio_2}
                    remedio_3={item.receita.remedio_3}
                    remedio_4={item.receita.remedio_4}
                    receitaId={item.id}
                    OpenModal={() => openModal(item)}
                  />
                </div>
              </div>
            )
          })
          : null}

      </div>

      <ModalComponent
        style={{ zIndex: 99999 }}
        openModal={visibleModal}
        closeModal={() => { setVisibleModal(false); carregar(); }}
      >
        <Receita
          item={itemReceita}
          usuario={usuario}
          idPaciente={paciente.id}
          paciente={null}
        />
      </ModalComponent>
    </>
  )
}

export default ContReceita;